import callAPiBase from './base';

const qualificationApi = {
  get: ({ ID }: { ID: string }) =>
    callAPiBase({
      endpoint: `/api/qualification?ID=${ID}`,
      method: 'GET',
      useToken: true,
    }),

  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: `/api/qualification`,
      method: 'POST',
      useApiToken: true,
      useToken: false,
      data
    }),
};

export { qualificationApi };
export default qualificationApi;
